
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
.ghs-logo {

    display: block;
}

  .ghs-logo .svg {

    width: 24rem;
}

:host([logo-variant='bhLogoBellinRunWhite']) {

    background-color: var(--bh-brand-primary-default);

    padding-left: 1.25rem;

    padding-right: 1.25rem;

    padding-top: 0.25rem;

    padding-bottom: 0.25rem;
}
`;